(function () {
  'use strict';

  const hasMeaningfulContent = (node) => {
    if (!node) return false;
    const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
    return text.length > 12 || !!node.querySelector('.jdgm-rev, .jdgm-rev-widg, .jdgm-prev-badge, [class*="jdgm-"]');
  };

  const realJudgeNodes = (root) => Array.from(root.querySelectorAll(
    '.shopify-block .jdgm-widget, .shopify-app-block .jdgm-widget, .jdgm-review-widget, .jdgm-rev-widg, [class*="jdgm-"], [id*="judgeme" i], [class*="judge-me" i]'
  )).filter((node) => !node.closest('[data-lorenzos-judgeme-fallback-reviews]') && !node.closest('[data-lorenzos-review-summary-fallback]'));

  const sync = () => {
    const summaryFallback = document.querySelector('[data-lorenzos-review-summary-fallback]');
    if (summaryFallback) {
      const buybox = summaryFallback.closest('.product-single__meta') || document;
      const appSummary = Array.from(buybox.querySelectorAll('.shopify-block, .shopify-app-block')).some((node) => /bewert|review|verifiziert|★/i.test((node.textContent || '').trim()));
      const realSummary = appSummary || realJudgeNodes(buybox).some((node) => {
        if (node.closest('.lorenzos-product-review-badge')) return false;
        if (node.classList && (node.classList.contains('jdgm-preview-badge') || node.classList.contains('jdgm-prev-badge'))) return false;
        return hasMeaningfulContent(node);
      });
      summaryFallback.hidden = realSummary;
    }

    const fullFallback = document.querySelector('[data-lorenzos-judgeme-fallback-reviews]');
    if (fullFallback) {
      const fallbackHasContent = hasMeaningfulContent(fullFallback);
      const realFull = realJudgeNodes(document).some((node) => {
        if (node.closest('.product-single__meta')) return false;
        if (node.classList && (node.classList.contains('jdgm-preview-badge') || node.classList.contains('jdgm-prev-badge'))) return false;
        return hasMeaningfulContent(node);
      });
      fullFallback.hidden = realFull || !fallbackHasContent;
    }
  };

  const schedule = () => {
    sync();
    [250, 700, 1400, 2800].forEach((delay) => window.setTimeout(sync, delay));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });
  document.addEventListener('shopify:section:load', schedule);

  const observer = new MutationObserver(() => window.requestAnimationFrame(sync));
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
